module.exports = __webpack_public_path__ + "img/EEG-filtered@2x.eb7f5102.png";